<form nz-form [formGroup]="form" nzLayout="vertical">
    <extend-form nz-row [nzGutter]="[20,20]">

        <extend-form-item labelText="Tên khách hàng" nz-col nzMd="24">
            <input type="text" nz-input formControlName="customerName" placeholder="" maxlength="200"
                   autocomplete="off">
        </extend-form-item>

        <extend-form-item labelText="Địa chỉ" nz-col nzMd="24">
            <input type="text" nz-input formControlName="address" placeholder="" maxlength="200" autocomplete="off">
        </extend-form-item>
        <extend-form-item labelText="Số điện thoại" nz-col nzMd="24">
            <input type="text" nz-input formControlName="phoneNumber" placeholder="" maxlength="200" autocomplete="off">
        </extend-form-item>
        <extend-form nz-col
                          nzMd="24">

            <div class="">
                <div class="c-title-form">
                    <button nz-button nzType="link" (click)="addItemOrderDetailForm()" class="btn-add-filed">
                        <i class="far fa-plus-square"></i>
                    </button>
                    Thêm mới chi tiết đơn hàng
                </div>
                <div class="c-form-content">
                    <div class="gr-form-dy" formArrayName="orderDetailForm">
                        <div class="item-filed"
                             *ngFor="let orderDetail of form.get('orderDetailForm')['controls']; let i = index"
                             [formGroupName]="i">
                            <div class="col-mdaaa">
                                <div class="row fff-end">
                                    <extend-form-item labelText="" nz-col nzMd="1">
                                        <span class="center">{{i + 1}}</span>
                                    </extend-form-item>
                                    <extend-form-item labelText="Sản phẩm" nz-col nzMd="9">
                                        <input type="text" nz-input formControlName="productDetail" placeholder=""
                                               maxlength="200" autocomplete="off">
                                    </extend-form-item>
                                    <extend-form-item
                                            nz-col
                                            nzMd="4"
                                            labelText="Số lượng">
                                        <nz-input-number class="w-100" nz-input formControlName="quantity"
                                                         [nzMin]="0" [nzStep]="1"
                                                         (keyup)="onChangeCaculatorAmountOrderDetail(i)">
                                        </nz-input-number>
                                    </extend-form-item>
                                    <extend-form-item
                                            nz-col
                                            nzMd="4"
                                            labelText="Đơn giá">
                                        <nz-input-number class="w-100" nz-input formControlName="price" [nzMin]="0"
                                                         [nzStep]="1000"
                                                         (keyup)="onChangeCaculatorAmountOrderDetail(i)">
                                        </nz-input-number>
                                    </extend-form-item>
                                    <extend-form-item
                                            nz-col
                                            nzMd="4"
                                            labelText="Thành tiền">
                                        <nz-input-number class="w-100" nz-input formControlName="subTotal" [nzMin]="0"
                                                         [nzStep]="1000">
                                        </nz-input-number>
                                    </extend-form-item>
                                    <extend-form-item
                                            nz-col
                                            nzMd="2"
                                    >
                                        <button nz-button nzType="primary" nzShape="circle"
                                                (click)="removeItemOrderDetailForm(i)">Xóa
                                        </button>
                                    </extend-form-item>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </extend-form>

        <extend-form-item
                nz-col
                nzMd="12"
                labelText="Số tiền">
            <nz-input-number class="w-100" nz-input formControlName="amount" [nzMin]="0" [nzStep]="1"
                             (ngModelChange)="calculatorAmount()">
            </nz-input-number>
        </extend-form-item>
        <extend-form-item
                nz-col
                nzMd="12"
                labelText="Tiền ship">
            <nz-input-number class="w-100" nz-input formControlName="shipFee" [nzMin]="0" [nzStep]="1"
                             (keyup)="calculatorAmount()">
            </nz-input-number>
        </extend-form-item>
        <extend-form-item
                nz-col
                nzMd="24"
                labelText="Tổng tiền" isRequired>
            <nz-input-number class="w-100" nz-input formControlName="totalAmount" [nzMin]="0" [nzStep]="1">
            </nz-input-number>
        </extend-form-item>
        <extend-form-item labelText="Kênh bán hàng" nz-col nzMd="12" [errorDefs]="VALIDATORS.channel"
                          [errors]="f.channel.errors" [showError]="isSubmitted" isRequired>
            <nz-select style="width: 100%" formControlName="channel">
                <nz-option [nzLabel]="'Trang cá nhân'" [nzValue]="1"></nz-option>
                <nz-option [nzLabel]="'Page'" [nzValue]="2"></nz-option>
                <nz-option [nzLabel]="'Khách lẻ'" [nzValue]="3"></nz-option>
            </nz-select>
        </extend-form-item>
        <extend-form-item labelText="Kênh thanh toán" nz-col nzMd="12" [errorDefs]="VALIDATORS.channelPayment"
                          [errors]="f.channelPayment.errors" [showError]="isSubmitted" isRequired>
            <nz-select style="width: 100%" formControlName="channelPayment">
                <nz-option [nzLabel]="'Chuyển khoản'" [nzValue]="1"></nz-option>
                <nz-option [nzLabel]="'Ship thu'" [nzValue]="2"></nz-option>
                <nz-option [nzLabel]="'Tiền mặt'" [nzValue]="3"></nz-option>
            </nz-select>
        </extend-form-item>

        <extend-form-item labelText="Link Fb" nz-col nzMd="24">
            <input type="text" nz-input formControlName="linkFb" placeholder="" maxlength="200" autocomplete="off">
        </extend-form-item>
    </extend-form>
    <extend-form-item nz-col nzMd="24" labelText="Mô tả">
        <nz-textarea-count [nzMaxCharacterCount]="200">
            <textarea formControlName="moreInfor" nz-input rows="2"></textarea>
        </nz-textarea-count>
    </extend-form-item>
    <extend-form-item labelText="Ngày giao hàng" nz-col nzMd="24">
        <nz-date-picker
                class="w-100"
                formControlName="orderDate"
                nzPlaceHolder="Chọn ngày giờ"
                [nzShowTime]="{ nzDefaultOpenValue: defaultTime, nzFormat: 'HH:mm' }"
                nzFormat="yyyy-MM-dd HH:mm">
        </nz-date-picker>
    </extend-form-item>
</form>

<ng-template #editFooter>
    <div class="d-flex justify-content-end">
        <button nz-button (click)="cancel()">Hủy</button>
        <button nz-button nzType="primary" (click)="submitForm()">Lưu</button>
    </div>
</ng-template>
